import Rest from '../Rest'

/**
 * Plano de cobrança vigente de um estabelecimento (aba do cadastro).
 * Reusa o recurso de legal_entities para o endpoint aninhado, como o
 * StripeConnectService faz.
 */
export default class LegalEntityFeePlanService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/legal_entities'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  currentPlan(legalEntityId: number) {
    return this.get(`/${legalEntityId}/fee_plan`)
  }
}
